// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://cra.link/PWA.'
              );

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl: string, config?: Config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      console.log('contentType, response.status', contentType, response.status);

      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {

        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
            console.log('inside navigator.serviceWorker.ready.then');
            registration.unregister().then(() => {
                window.location.reload();
            });
        });
      } else {
        // Service worker found. Proceed as normal.
        console.log('Service worker found. Proceed as normal');
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

// async function cache(auditId: string, photoId: string, onlineURL: string) {
//     const swCache = await caches.open(WS_OFFLINE_IMAGE_CACHE);
//     const offlineURL = photos.magicUrl(auditId, photoId);
//     const swCachedResponse = await swCache.match(offlineURL);
//     if (!swCachedResponse) {
//         // todo maybe we can avoid magic link and always use google cloud real one
//         // remove all below and use this then swCache.add(onlineURL);
//         console.log('onlineURL', onlineURL);
//         fetch(onlineURL)
//             .then(async (response) => {
//                 console.log('cache response', response);
//                 if (response.ok) {
//                     swCache.put(offlineURL, response);
//                 }
//             })
//             .catch(async (_) => {
//                 console.error('Cannot fetch image', {offlineURL});
//             });
//     }
// }

export function refreshCacheAndReload() {
    console.log("refreshCacheAndReload.");

    if ('serviceWorker' in navigator) {
        console.log("navigator.serviceWorker.controller.", navigator.serviceWorker.controller);
        navigator.serviceWorker.ready.then((registration) => {
            registration.unregister().then(() => {
                console.log('unregistered');
                caches.keys().then(cacheNames => {
                    cacheNames.forEach(cacheName => {
                        caches.delete(cacheName);
                    });
                }).then(() => {
                    console.log('caches.deleted');
                    window.location.reload();
                })
            });
        });
    }
    else {
        console.log("Service workers are not supported.");
    }
}

// function registerPhotosSync() {
//     let intervalID = null;
//     const goOffline = () => {
//         if (!navigator.onLine) {
//             console.log("addEventListener register offline", intervalID);
//             if (intervalID) clearInterval(intervalID);
//             intervalID = null;
//         }
//     }
//     window.removeEventListener("offline", goOffline);
//     window.addEventListener("offline", goOffline);

//     const goOnline = async () => {
//         if (navigator.onLine) {
//             console.log("addEventListener register online", intervalID);
//             if (intervalID) clearInterval(intervalID);
//             intervalID = setInterval(() => { sync(cache) }, 5000);
//         }   
//     };
//     window.removeEventListener("online", goOnline);
//     window.addEventListener("online", goOnline);
//     goOnline();
// }

export function register(config?: Config) {
  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    // registerPhotosSync();

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    
      console.log('process.env', process.env);
      if (isLocalhost) {
        console.log('isLocalhost');
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA'
          );
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
  else {
    console.log("Service workers are not supported.");
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
